import React from "react";
import { GridItem } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { Modal, Select } from "components";
import { isToothFilled, useCurrentCase } from "duck";
import { DENTAL_CHART_OPTIONS } from "./duck";

const DentalChart: React.FC = () => {
  const { setValue, watch } = useFormContext();
  const dentalChartValue = watch("dentalChart");

  const { hasTeethData, hasDentalComments, hasDentalSketch } = useCurrentCase(
    ({ data }) => ({
      hasTeethData:
        data.client.patient.dentalChartings?.some(chart =>
          isToothFilled(chart, true)
        ) || false,
      hasDentalSketch: !!data.client.patient.dentalSketch,
      hasDentalComments: data.client.patient.dentalSketchComments.length > 0
    })
  );
  const dentalChartingFilled =
    hasTeethData || hasDentalSketch || hasDentalComments;

  return (
    <GridItem>
      <Select
        name="dentalChart"
        options={DENTAL_CHART_OPTIONS}
        placeholder="Select"
        label="Dental Chart"
        onChange={value => {
          if (!dentalChartValue || !dentalChartingFilled) {
            setValue("dentalChart", value);
            return;
          }

          if (value !== dentalChartValue) {
            Modal.instance.open({
              title: "Remove Dental Chart data",
              description:
                "Are you sure you want to change this chart? Data connected with this chart will be deleted and you will not be able to undo this action.",
              onOk() {
                setValue("dentalChart", value);
              }
            });
          }
        }}
      />
    </GridItem>
  );
};

export default DentalChart;
